export const messages = {
  en: {
    editQuestionAnswer: {
      title: 'Edit Questionnaire',
      qaName: 'Questionnaire Name',
      qaNamePlaceholder: 'Required, please enter questionnaire name',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      content: 'Questionnaire Description',
      contentPlaceholder: 'Required, please enter questionnaire description',
      questionTitle: 'Questionnaire Questions',
      chooseTitle: 'Select Questions',
      questionRooms: 'Questionnaire Rooms',
      household: 'households',
      reselect: 'Reselect',
      save: 'Save',
      cancel: 'Cancel',
      table: {
        name: 'Name',
        type: 'Type',
        options: 'Options',
        actions: 'Actions',
        delete: 'Delete'
      },
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      shortAnswer: 'Short Answer',
      duplicateTitle: 'Please do not select duplicate questions',
      validate: {
        qaName: 'Questionnaire name cannot be empty',
        startTime: 'Start time cannot be empty',
        endTime: 'End time cannot be empty',
        timeError: 'Start time must be earlier than end time'
      },
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed'
    },
    selectRoom: {
      buildingUnit: 'Building Unit',
      roomInfo: 'Room Information'
    },
    chooseQuestionTitle: {
      title: 'Select Questions',
      searchPlaceholder: 'Enter question name',
      table: {
        title: 'Question',
        createTime: 'Create Time',
        actions: 'Actions',
        choose: 'Select'
      }
    }
  },
  zh: {
    editQuestionAnswer: {
      title: '修改问卷',
      qaName: '问卷名称',
      qaNamePlaceholder: '必填，请填写问卷名称',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间',
      content: '问卷说明',
      contentPlaceholder: '必填，请输入问卷说明',
      questionTitle: '问卷题目',
      chooseTitle: '选择题目',
      questionRooms: '问卷房屋',
      household: '户',
      reselect: '重新选择',
      save: '保存',
      cancel: '取消',
      table: {
        name: '名称',
        type: '类型',
        options: '选项',
        actions: '操作',
        delete: '删除'
      },
      singleChoice: '单选',
      multipleChoice: '多选',
      shortAnswer: '简答',
      duplicateTitle: '请勿重复选择题目',
      validate: {
        qaName: '问卷名称不能为空',
        startTime: '开始时间不能为空',
        endTime: '结束时间不能为空',
        timeError: '开始时间必须小于结束时间'
      },
      updateSuccess: '修改成功',
      updateFailed: '修改失败'
    },
    selectRoom: {
      buildingUnit: '楼栋单元',
      roomInfo: '房屋信息'
    },
    chooseQuestionTitle: {
      title: '选择题目',
      searchPlaceholder: '输入题目名称',
      table: {
        title: '题目',
        createTime: '创建时间',
        actions: '操作',
        choose: '选择'
      }
    }
  },
  'zh-TW': {
    editQuestionAnswer: {
      title: '修改問卷',
      qaName: '問卷名稱',
      qaNamePlaceholder: '必填，請填寫問卷名稱',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請選擇開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請選擇結束時間',
      content: '問卷說明',
      contentPlaceholder: '必填，請輸入問卷說明',
      questionTitle: '問卷題目',
      chooseTitle: '選擇題目',
      questionRooms: '問卷房屋',
      household: '戶',
      reselect: '重新選擇',
      save: '保存',
      cancel: '取消',
      table: {
        name: '名稱',
        type: '類型',
        options: '選項',
        actions: '操作',
        delete: '刪除'
      },
      singleChoice: '單選',
      multipleChoice: '多選',
      shortAnswer: '簡答',
      duplicateTitle: '請勿重複選擇題目',
      validate: {
        qaName: '問卷名稱不能為空',
        startTime: '開始時間不能為空',
        endTime: '結束時間不能為空',
        timeError: '開始時間必須小於結束時間'
      },
      updateSuccess: '修改成功',
      updateFailed: '修改失敗'
    },
    selectRoom: {
      buildingUnit: '樓棟單元',
      roomInfo: '房屋信息'
    },
    chooseQuestionTitle: {
      title: '選擇題目',
      searchPlaceholder: '輸入題目名稱',
      table: {
        title: '題目',
        createTime: '創建時間',
        actions: '操作',
        choose: '選擇'
      }
    }
  }
};